import { TICKS_POLLING_INTERVAL } from '../config/main-config'

export class TickSyncWatcher {
  #interval
  #timer
  constructor (handler, interval = TICKS_POLLING_INTERVAL) {
    this.#interval = +interval
    this.#timer = null
    this.handler = handler
  }

  start () {
    this.#timer = setInterval(this.handler, this.#interval)
  }

  stop () {
    clearInterval(this.#timer)
  }
}
